import React from 'react';
import { Grid, Card, CardContent, Typography, Container, useMediaQuery, useTheme } from '@mui/material';
import { FaHtml5, FaCss3Alt, FaReact, FaJs, FaPython, FaJava, FaSass, FaDatabase, FaNodeJs, FaBootstrap, FaCloud, FaCode, FaCogs, FaDocker, FaGitAlt } from 'react-icons/fa';
import { DiMaterializecss } from 'react-icons/di';
import { SiJson, SiMongodb, SiNetapp, SiC, SiCplusplus, SiSpring, SiWindows, SiLinux, SiIos, SiAmazonaws, SiMicrosoftazure, SiGooglecloud, SiKubernetes, SiPacker, SiTerraform, SiSwagger, SiJenkins } from 'react-icons/si';
import { RiDatabase2Line } from 'react-icons/ri';

const skills = [
    { name: 'HTML', icon: <FaHtml5 color="#E34F26" size="3em" /> },
    { name: 'CSS', icon: <FaCss3Alt color="#1572B6" size="3em" /> },
    { name: 'JavaScript', icon: <FaJs color="#F7DF1E" size="3em" /> },
    { name: 'React', icon: <FaReact color="#61DAFB" size="3em" /> },
    { name: 'Spring Boot', icon: <SiSpring color="#6DB33F" size="3em" /> },
    { name: 'Web Design', icon: <FaCode color="#FF5733" size="3em" /> },
    { name: 'Full-Stack Development', icon: <FaCode color="#00ADEF" size="3em" /> },
    { name: 'Windows', icon: <SiWindows color="#00A4EF" size="3em" /> },
    { name: 'Linux', icon: <SiLinux color="#FCC624" size="3em" /> },
    { name: 'iOS', icon: <SiIos color="#000000" size="3em" /> },
    { name: 'AWS', icon: <SiAmazonaws color="#FF9900" size="3em" /> },
    { name: 'Microsoft Azure', icon: <SiMicrosoftazure color="#0078D4" size="3em" /> },
    { name: 'Google Cloud', icon: <SiGooglecloud color="#4285F4" size="3em" /> },
    { name: 'Kubernetes', icon: <SiKubernetes color="#326CE5" size="3em" /> },
    { name: 'Packer', icon: <SiPacker color="#FAFAFA" size="3em" /> },
    { name: 'Terraform', icon: <SiTerraform color="#5C4EE5" size="3em" /> },
    { name: 'Networking', icon: <FaCloud color="#00ADEF" size="3em" /> },
    { name: 'Data Structures', icon: <FaDatabase color="#FF5733" size="3em" /> },
    { name: 'OOP', icon: <FaCogs color="#FF5733" size="3em" /> },
    { name: 'MySQL', icon: <FaDatabase color="#4479A1" size="3em" /> },
    { name: 'MongoDB', icon: <SiMongodb color="#47A248" size="3em" /> },
    { name: 'Postman', icon: <FaCode color="#FF6C37" size="3em" /> },
    { name: 'Swagger', icon: <SiSwagger color="#85EA2D" size="3em" /> },
    { name: 'Jenkins', icon: <SiJenkins color="#D24939" size="3em" /> },
    { name: 'Docker', icon: <FaDocker color="#2496ED" size="3em" /> },
    { name: 'Git', icon: <FaGitAlt color="#F05032" size="3em" /> },
    { name: 'GitHub', icon: <FaGitAlt color="#181717" size="3em" /> },
    { name: 'CI/CD', icon: <FaCogs color="#808080" size="3em" /> },
    { name: 'API Design', icon: <FaCogs color="#FF5733" size="3em" /> },
    { name: 'Cross-Functional Collaboration', icon: <FaCode color="#00ADEF" size="3em" /> },
    { name: 'AWS RDS', icon: <RiDatabase2Line color="#232F3E" size="3em" /> },
    { name: 'Sass', icon: <FaSass color="#CC6699" size="3em" /> },
    { name: 'Bootstrap', icon: <FaBootstrap color="#7952B3" size="3em" /> },
    { name: 'Material-UI', icon: <DiMaterializecss color="#0081CB" size="3em" /> },
    { name: 'JSON', icon: <SiJson color="#000000" size="3em" /> },
    { name: 'Java', icon: <FaJava color="#007396" size="3em" /> },
    { name: 'Python', icon: <FaPython color="#3776AB" size="3em" /> },
    { name: 'C language', icon: <SiC color="#A8B9CC" size="3em" /> },
    { name: 'C++', icon: <SiCplusplus color="#00599C" size="3em" /> },
    { name: 'Node.js', icon: <FaNodeJs color="#339933" size="3em" /> },
    { name: 'Cloud Computing', icon: <FaCloud color="#00ADEF" size="3em" /> },
    { name: 'Java Swing', icon: <FaJava color="#007396" size="3em" /> },
    { name: 'NetApp ASE 1', icon: <SiNetapp color="#0052CC" size="3em" /> },
    { name: 'NetApp ASE 2', icon: <SiNetapp color="#0052CC" size="3em" /> },
    { name: 'NetApp ASE 3', icon: <SiNetapp color="#0052CC" size="3em" /> },
];

const Skills = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container>
      <Typography
        variant="h4"
        component="div"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          fontSize: isMobile ? '30px' : '40px',
          color: 'black',
          marginBottom: '3%',
        }}
      >
        <span style={{ color: '#f9004d' }}>My</span> Skills
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {skills.map((skill) => (
          <Grid item key={skill.name} xs={5} sm={6} md={4} lg={3}>
            <Card sx={{
              display: 'flex',
              flexDirection: 'column',
              transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
              '&:hover': {
                transform: 'scale(1.05)',  // Scales up the card
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)'  // Adds shadow on hover
              }
            }}>
              <CardContent style={{ textAlign: 'center' }}>
                <Typography variant="h5" component="div">
                  {skill.icon}
                </Typography>
                <Typography variant="h6" component="div">
                  {skill.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Skills;
